import classNames from 'classnames';

import ZipForm from '~components/ZipCodeForm/ZipCodeForm';

type Props = {
    buttonstyletype?: string;
    buttontitle?: string;
    buttonwalink: string;
    doctortool?: boolean;
    drugtool?: boolean;
    fastquote?: boolean;
    fontcolor?: string;
    isvertical?: boolean;
    qavalue?: string;
    submittrackingactionname?: string;
};

const ZipFormBlockWrapper = ({
    buttonstyletype = 'primary',
    buttontitle = 'See Plans',
    buttonwalink,
    doctortool,
    drugtool,
    fastquote,
    fontcolor,
    isvertical = false,
    qavalue = 'web-component',
    submittrackingactionname,
}: Props) => {
    return (
        <div className={classNames(isvertical && 'max-w-72 mx-auto')}>
            <ZipForm
                buttonTitle={buttontitle}
                buttonWaLink={buttonwalink}
                qaValue={qavalue}
                redirect={{
                    withTool: doctortool ? 'doctor' : drugtool ? 'drug' : undefined,
                    withFastQuote: fastquote,
                }}
                opts={{
                    btnStyle: buttonstyletype,
                    useWhiteText: fontcolor === 'white',
                    forceVerticalLayout: isvertical,
                }}
                submitTrackingActionName={submittrackingactionname}
            />
        </div>
    );
};

export default ZipFormBlockWrapper;
